import TePage from './index.vue';


TePage.install = function(Vue) {
  Vue.component(TePage.name, TePage);
};

export default TePage;